import { render, staticRenderFns } from "./standart.vue?vue&type=template&id=aa6f604c&scoped=true&"
import script from "./standart.vue?vue&type=script&lang=js&"
export * from "./standart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6f604c",
  null
  
)

export default component.exports